import {array, number, object, string} from 'yup';

import {
  localizedTextOptionalNullable,
  localizedTextRequired,
  stringOptionalNullable,
} from '@shared/utils';

export const categoryV8nSchema = object().shape({
  id: string().required(),
  name: string().required(),
  description: string().nullable().optional(),
  logo_url: string().nullable().optional(),
  banner_url: string().nullable().optional(),
  order: number().optional(),
});

export const adminCategoryDetailV8nSchema = object().shape({
  id: string().required(),
  name: localizedTextRequired,
  description: localizedTextOptionalNullable,
  logo_url: string().nullable().optional(),
  banner_url: string().nullable().optional(),
  order: number().optional(),
});

export const v8nSchemaOfGetCategoriesResponse = array().of(categoryV8nSchema);

export const subCategoryV8nSchema = object()
  .shape({
    id: stringOptionalNullable,
    slug: stringOptionalNullable,
    name: localizedTextRequired,
  })
  .test({
    name: 'sub-category-id',
    message: 'Either id or slug should be present',
    test(value) {
      return Boolean(value?.id || value?.slug);
    },
  });

export const v8nSchemaOfGetSubCategoriesResponse =
  array().of(subCategoryV8nSchema);

export const adminSubCategoryV8nSchema = object().shape({
  id: stringOptionalNullable,
  slug: string().required(),
  name: localizedTextRequired,
  geos: array().of(string()).optional(),
  logo_url: string().nullable().optional(),
  banner_url: string().nullable().optional(),
  published_events_count: number().nullable().optional(),
  active_events_count: number().nullable().optional(),
});

export const v8nSchemaOfGetAdminSubCategoriesResponse = array().of(
  adminSubCategoryV8nSchema,
);
